// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  height: 100%;
}

body {
  background-color: #181818;
  font-size: 24px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande',
    'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

#root {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

main {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  flex-direction: column;
}

main.name-select {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

.logo {
  position: absolute;
  top: 24px;
  left: 36px;
}

p {
  margin: 0 0 5px 0;
}

input[type='text'] {
  font-family: Open Sans;
  font-size: 20px;
  text-align: center;
  letter-spacing: 0.01em;
  font-feature-settings: 'pnum' on, 'onum' on;
  color: #2d2d2d;
  padding: 12px 66px 10px;
  background: #e0e0e0;
  box-shadow: inset 14px 8px 0px rgba(101, 101, 101, 0.8);
  outline: none;
  border: none;
  margin-bottom: 24px;
  max-width: 90%;
  box-sizing: border-box;
}

.btn {
  background-color: #504dd2;
  border: none;
  padding: 8px 64px;
  background: #504dd2;
  box-shadow: 4px 8px 0px rgba(0, 0, 0, 0.25);
  border-radius: 32px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 162.5%;
  color: #f4f4f4;
  outline: none;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.horizontal {
  flex-direction: row;
}

.joystick {
  position: absolute;
  bottom: 20px;
  right: 24px;
  z-index: 100;
  display: none;
}

@media only screen and (max-width: 600px) {
  .joystick {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf;sDACoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mDAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;EAC3C,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,uDAAuD;EACvD,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["html,\nbody {\n  margin: 0;\n  height: 100%;\n}\n\nbody {\n  background-color: #181818;\n  font-size: 24px;\n  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande',\n    'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n}\n\n#root {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\nmain {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  flex-direction: column;\n}\n\nmain.name-select {\n  background: url(./assets/bg.png);\n  background-size: cover;\n}\n\n.logo {\n  position: absolute;\n  top: 24px;\n  left: 36px;\n}\n\np {\n  margin: 0 0 5px 0;\n}\n\ninput[type='text'] {\n  font-family: Open Sans;\n  font-size: 20px;\n  text-align: center;\n  letter-spacing: 0.01em;\n  font-feature-settings: 'pnum' on, 'onum' on;\n  color: #2d2d2d;\n  padding: 12px 66px 10px;\n  background: #e0e0e0;\n  box-shadow: inset 14px 8px 0px rgba(101, 101, 101, 0.8);\n  outline: none;\n  border: none;\n  margin-bottom: 24px;\n  max-width: 90%;\n  box-sizing: border-box;\n}\n\n.btn {\n  background-color: #504dd2;\n  border: none;\n  padding: 8px 64px;\n  background: #504dd2;\n  box-shadow: 4px 8px 0px rgba(0, 0, 0, 0.25);\n  border-radius: 32px;\n  font-family: Open Sans;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 20px;\n  line-height: 162.5%;\n  color: #f4f4f4;\n  outline: none;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.horizontal {\n  flex-direction: row;\n}\n\n.joystick {\n  position: absolute;\n  bottom: 20px;\n  right: 24px;\n  z-index: 100;\n  display: none;\n}\n\n@media only screen and (max-width: 600px) {\n  .joystick {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
